<div id="head"></div>
<h1 class="sr-only">AI API Cost Calculator - Monthly Cost of Claude, GPT and Gemini Requests</h1>

<!-- ===================== Hero: the calculator itself ===================== -->
<div class="default-section initial-section metallic-section no-buttons wp-hero" data-section="top">
  <div class="cp-hero-head">
    <p class="tools-title" aria-hidden="true">AI Cost Calculator</p>
    <p class="tools-subtitle">What your app would cost a month on every AI model</p>
  </div>

  <app-ai-cost-widget [values]="values" [scenarioKey]="scenario.key" [modelId]="modelId" (cardChange)="onCard( $event )"></app-ai-cost-widget>
</div>

<nav class="cp-chipbar" appStuck aria-label="AI cost calculator sections">
  <div class="cp-chipbar-row">
    <a *ngFor="let s of pageSections" class="pl-chip" [class.on]="activeSection === s.key" [attr.href]="'#sec-' + s.key"
       (click)="$event.preventDefault(); scrollToSection( s.key )">
      <span>{{ s.label }}</span>
    </a>
  </div>
</nav>

<div class="cp-body cp-boxes">
  <div class="cp-content">

    <!-- every model at the visitor's numbers, cheapest first; a row puts its model in the card above -->
    <section class="cp-section" id="sec-compare" data-section="compare">
      <header class="cp-head">
        <h2 class="cp-h2">Compare Every Model</h2>
        <p class="cp-section-lead">What the same app costs on every model and platform, cheapest first; click a row to see it in the calculator</p>
      </header>
      <div class="cp-main">
          <div class="ap-controls">
        <nav class="ap-platforms" aria-label="Platforms">
          <button type="button" class="pl-chip" [class.on]="platform === 'all'" (click)="setPlatform( 'all' )"><span>All Platforms</span></button>
          <button type="button" class="pl-chip" *ngFor="let key of platformKeys" [class.on]="platform === key" (click)="setPlatform( key )"><img class="ap-picon" [src]="platformIcon( key )" alt="" width="16" height="16"><span>{{ platformLabel( key ) }}</span></button>
        </nav>
        <label class="ap-search">
          <span class="sr-only">Search models</span>
          <input type="search" [ngModel]="query" (ngModelChange)="setQuery( $event )" placeholder="Search a model, a vendor or a platform" autocomplete="off" spellcheck="false">
        </label>
      </div>

      <div class="ap-table-wrap" *ngIf="rows.length; else empty">
        <table class="ap-table">
          <thead>
            <tr>
              <th scope="col"><button type="button" class="ap-sort" [class.on]="sortKey === 'name'" [class.desc]="sortKey === 'name' && sortDesc" (click)="sortBy( 'name' )">Model</button></th>
              <th scope="col"><button type="button" class="ap-sort" [class.on]="sortKey === 'platform'" [class.desc]="sortKey === 'platform' && sortDesc" (click)="sortBy( 'platform' )">Platform</button></th>
              <th scope="col" class="ap-num"><button type="button" class="ap-sort" [class.on]="sortKey === 'month'" [class.desc]="sortKey === 'month' && sortDesc" (click)="sortBy( 'month' )">Per Month</button></th>
              <th scope="col" class="ap-num"><button type="button" class="ap-sort" [class.on]="sortKey === 'day'" [class.desc]="sortKey === 'day' && sortDesc" (click)="sortBy( 'day' )">Per Day</button></th>
              <th scope="col" class="ap-num"><button type="button" class="ap-sort" [class.on]="sortKey === 'request'" [class.desc]="sortKey === 'request' && sortDesc" (click)="sortBy( 'request' )">Per {{ scenario.one }}</button></th>
              <th scope="col" class="ap-num" *ngIf="values.budget > 0"><button type="button" class="ap-sort" [class.on]="sortKey === 'budget'" [class.desc]="sortKey === 'budget' && sortDesc" (click)="sortBy( 'budget' )">{{ scenario.many }} a Day for {{ money( values.budget ) }}</button></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of rows" class="ac-row" [class.on]="chosenId === r.model.id" (click)="pickModel( r )">
              <td><span class="ap-name">{{ r.model.name }}</span><span class="ap-id">{{ r.model.vendor }} · {{ price( r.model.input ) }} in, {{ price( r.model.output ) }} out per 1M</span></td>
              <td><span class="ap-plat"><img class="ap-picon" [src]="platformIcon( r.model.platform )" alt="" width="16" height="16">{{ platformLabel( r.model.platform ) }}</span></td>
              <td class="ap-num ac-month">{{ money( r.perMonth ) }}</td>
              <td class="ap-num ap-dim">{{ money( r.perDay ) }}</td>
              <td class="ap-num ap-dim">{{ money( r.perRequest ) }}</td>
              <td class="ap-num" *ngIf="values.budget > 0">{{ count( r.withinBudget ) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #empty>
        <p class="ap-empty" *ngIf="data">No model matches. Try another word or pick another platform</p>
        <p class="ap-empty" *ngIf="!data">Loading the prices</p>
      </ng-template>
      <p class="ap-foot">An estimate from the daily price table, cheapest first; click a column to sort by it. Words become tokens at about 750 words per thousand; code and other languages use more. Check the vendor pricing page before a large commitment</p>
      </div>
    </section>

    <!-- More AI Tools (owner 2026-10-22): AI Token Meter, the menu bar app that counts the tokens this calculator
         prices, just above How It Works -->
    <app-more-tools title="More AI Tools" lead="Count the tokens your coding agents really use, then price them here"
                    [app]="aiTokenMeter" source="ai-cost-calculator"></app-more-tools>

    <app-tool-about [lead]="aboutLead" [paragraphs]="aboutParagraphs" [faq]="faq" ratingKey="ai-cost-calculator" ratingName="the AI Cost Calculator"></app-tool-about>

  </div>
</div>
